// Website languages, in the order of the language switcher.
// No imports on purpose: middleware.ts uses this file, and anything imported here is bundled into the
// middleware that runs on every request (flags and translations live in app/[lang]/dictionaries.ts).
export const LANGUAGES = [
  { link: 'en', name: 'English' },
  { link: 'pt', name: 'Portuguese' },
  { link: 'es', name: 'Spanish' },
  { link: 'zh', name: 'Chinese' },
  { link: 'ru', name: 'Russian' },
  { link: 'hi', name: 'Hindi' },
  { link: 'ar', name: 'Arabic' },
  { link: 'fr', name: 'French' },
  { link: 'id', name: 'Indonesian' },
  { link: 'th', name: 'Thai' },
  { link: 'vi', name: 'Vietnamese' },
] as const;

export const LANGUAGE_CODES: string[] = LANGUAGES.map(({ link }) => link);
